const Shimmer = () => {
  return (
    <div className="animate-pulse flex space-x-4">
      <div className=" bg-slate-200 h-[15vh] w-full"></div>
    </div>
  );
};

export default Shimmer;
